<div class="modal-header">
  <h5 class="modal-title">Informações de perfil</h5>
</div>

<div class="modal-body" [formGroup]="form">
  <div class="form-row">
    <div class="col">
      <div class="form-group">
        <label>Perfil</label>
        <select formControlName="profile_type" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && form.get('profile_type').hasError('required') }">
          <option title="Selecione..." value="" label="Selecione..." selected="selected" disabled>Selecione...</option>
          <option *ngFor="let profile of profiles" value="{{ profile.id }}">{{ profile.description }}</option>
        </select>
        <small class="invalid-feedback" *ngIf="form.get('profile_type').hasError('required')">
          Perfil não foi informada
        </small>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-link mainFontColor" (click)="activeModal.dismiss()">Voltar</button>
  <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader class="btn btn-primary mainBackground-color">
    Salvar
  </button>
</div>
